import { Reducer } from 'redux';
import { ParticipantActionTypes, ParticipantState } from './types';
import { SharedActionTypes } from '../shared/types';

const initialState: ParticipantState = {
  data: {
    byId: {},
    allIds: [],
    byEvent: {}
  },
  errors: undefined,
  loading: false
};

const reducer: Reducer<ParticipantState> = (state = initialState, action) => {
  switch (action.type) {
    case ParticipantActionTypes.REQUEST:
    case ParticipantActionTypes.REGISTER_REQUEST: {
      return { ...state, loading: true };
    }
    case ParticipantActionTypes.DELETE_SUCCESS:
    case ParticipantActionTypes.UPDATE_SUCCESS:
    case ParticipantActionTypes.REGISTER_SUCCESS: {
      return { ...state, loading: false, errors: null };
    }
    case ParticipantActionTypes.ERROR:
    case ParticipantActionTypes.REGISTER_ERROR: {
      return { ...state, loading: false, errors: action.payload };
    }
    case SharedActionTypes.RESET: {
      return initialState;
    }
    default:
      return state;
  }
};

export { reducer as ParticipantReducer };



// WEBPACK FOOTER //
// ./src/store/participant/reducer.ts